import { CamelCaseKeys } from '@utils/typescript';
import { InsuranceTypesEnum } from '@models/InsuranceType';
import { tEnum } from '../components/i18n';

export enum BillingTypes {
  Reimbursement = 'reimbursement',
  DirectBilling = 'direct_billing'
}

export enum BillingTypeCodes {
  Reimbursement = 'RI',
  DirectBilling = 'DB'
}

export const BillingTypeCodeToTypeMapping = {
  [BillingTypeCodes.Reimbursement]: BillingTypes.Reimbursement,
  [BillingTypeCodes.DirectBilling]: BillingTypes.DirectBilling,
};

export enum ClaimStatuses {
  Open = 'open',
  InReview = 'in_review',
  InProgress = 'in_progress',
  Approved = 'approved',
  PaymentProcessing = 'payment_processing',
  Closed = 'closed',
  Voided = 'voided',
  SettlementOffered = 'settlement_offered'
}

export enum ClaimableTypes {
  Car = 'CarClaim',
  PersonalAccident = 'PersonalAccidentClaim',
  Cancer = 'CancerClaim',
  CorporateHealth = 'CorporateHealthClaim',
  Health = 'HealthClaim',
}

export type ClaimList = CamelCaseKeys<{
  id: number;
  claimable_id: number;
  claimable_type: ClaimableTypes;
  insurance_type: InsuranceTypesEnum;
  order_number: string;
  policy_number: string;
  claim_number: string;
  status: ClaimStatuses;
  billing_type_code: string;
  created_at: number;
}>;

export type Claim = ClaimList &
  CamelCaseKeys<{
    note: string;
    total_claimed_amount: number;
    approved_amount: number;
  }>;

const CLAIM_STATUSES_VARIANTS_MAPPING = {
  [ClaimStatuses.Open]: 'primary',
  [ClaimStatuses.InReview]: 'info',
  [ClaimStatuses.InProgress]: 'info',
  [ClaimStatuses.Approved]: 'success',
  [ClaimStatuses.PaymentProcessing]: 'secondary',
  [ClaimStatuses.Closed]: 'dark',
  [ClaimStatuses.Voided]: 'danger',
  [ClaimStatuses.SettlementOffered]: 'warning',
};

export const getClaimStatusVariant = (status: ClaimStatuses) => {
  return CLAIM_STATUSES_VARIANTS_MAPPING[status];
};

export const tClaimStatus = (status: ClaimStatuses) => tEnum('claimStatuses', status);
